import { Menu, Switch } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { projectsMenuEvents } from 'app/modules/wallforming/components/projects-manager/types/projectsMenuEvents';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const AutosaveToggle = () => {
    const { t } = useTranslation();
    const { isAutosaveEnabled, hasActiveProject } = usePlacementStore(
        useShallow((state) => ({
            isAutosaveEnabled: state.isAutosaveEnabled,
            hasActiveProject: state.activeProject !== null
        }))
    );

    const toggleAutosave = () => {
        if (!hasActiveProject) {
            return;
        }
        window.dispatchEvent(new Event(projectsMenuEvents.toggleAutosave));
    };

    return (
        <Menu.Item
            closeMenuOnClick={false}
            disabled={!hasActiveProject}
            leftSection={
                <Icon className="action-menu-entry-decoration action-menu-entry-decoration-icon" icon="sync" />
            }
            rightSection={
                <span className="flex items-center justify-center">
                    <Switch
                        aria-label={t('projectsAutosaveToggle', 'Autosave')}
                        checked={isAutosaveEnabled}
                        color="blue"
                        disabled={!hasActiveProject}
                        label={'\u200b'}
                        size="sm"
                        onChange={toggleAutosave}
                        onClick={(event) => event.stopPropagation()}
                    />
                </span>
            }
            onClick={toggleAutosave}
        >
            {t('projectsAutosaveToggle', 'Autosave')}
        </Menu.Item>
    );
};
